export function memoize<A extends string | number, B>(f: (args: A) => B): (a: A) => B {
  return cached(f);
}
export function memoizes<A extends any[], B>(f: (...args: A) => B): (...args: A) => B {
  return cached(f, (...k) => JSON.stringify(k));
}
function cached<K extends any[], V>(f: (...k: K) => V, kf?: (...k: K) => number | string): (...k: K) => V {
  let m: (...k: K) => V;
  let v: V;
  return (...k: K) => {
    if (!k || k.length === 0) {
      if (!v) {
        v = f(...k);
      }
      return v;
    } else {
      if (!m) {
        m = cachedMap(f, kf);
      }
      return m(...k);
    }
  };
}
function cachedMap<K extends any[], V>(f: (...k: K) => V, kf?: (...k: K) => number | string): (...k: K) => V {
  const mem = new Map<string | number, V>();
  return (...k: K) => {
    const key = kf ? kf(...k) : k[0];
    if (mem.has(key)) {
      return mem.get(key) as V;
    } else {
      const v = f(...k);
      mem.set(key, v);
      return v;
    }
  };
}
